<template>
  <div :class="$b({ size })">
    <h2
      v-if="showPrescriptionTitle"
      :class="$b('prescription-title')"
    >
      Prescription
    </h2>
    <h2 v-if="frameType" :class="$b('frame-type')">
      <!-- eslint-disable vue/no-v-html -->
      <span
        v-html="frameTypeFull"
      />
      <!-- eslint-ensable vue/no-v-html -->
    </h2>
    <div :class="$b('container')">
      <ProductTitle
        :product-name="strippedProductName"
        :frame-type="frameType"
        :subtitle="expandedSubtitle"
        :subtitle-above-title="subtitleAboveTitle"
        :class="$b('product-title')"
        :size="size"
      />
      <div :class="$b('reviews-container')">
        <button
          v-if="showReviews"
          @click="$emit('launch-reviews')"
        >
          <ProductReviewStars
            :rating="reviewSummary.averageStars"
            :count="reviewSummary.count"
          />
        </button>
      </div>
    </div>
    <h6 :class="$b('product-description')">
      <ProductDescription :customised-product="customisedProduct" />
    </h6>
    <h6 :class="$b('product-price')">
      <ProductPrice
        :pre-discount-price="preDiscountPrice"
        :price="price"
        :is-minimum-price="isMinimumPrice"
      />
    </h6>
  </div>
</template>

<script>
import getFrameTypes from '~/assets/js/constants/frameTypes'

export default {
  name: 'ProductTitleSection',

  props: {
    customisedProduct: { type: Object, default: () => ({}) },
    productName: { type: String, required: true },
    frameType: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    subtitleAboveTitle: { type: Boolean, default: true },
    showPrescriptionTitle: { type: Boolean, default: false },
    showReviews: { type: Boolean, default: true },
    reviewSummary: { type: Object, default: () => ({}) },
    size: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['small', 'medium'].includes(value)
      },
    },
    preDiscountPrice: { type: Number, required: false, default: 0 },
    price: { type: [Number, Object], default: 0 },
    isMinimumPrice: { type: Boolean, default: false },
  },

  emits: ['launch-reviews'],

  setup() {
    const sidebarStore = useSidebarStore()

    return { sidebarStore }
  },

  computed: {
    productNameParts() {
      const match = this.productName.match(/^(.+?) <sp.+?>(.+?)</m)
      return match ? [match[1], match[2]] : null
    },
    strippedProductName() {
      // Don't alter the product name if we've already got a subtitle
      if (this.subtitle || !this.productNameParts) return this.productName
      return this.productNameParts[0]
    },
    expandedSubtitle() {
      // Don't show subtitle if limited edition is true
      if (this.customisedProduct.isLimitedEdition) return
      // Don't alter the product name if we've already got a subtitle
      if (this.subtitle || !this.productNameParts) return this.subtitle
      return this.productNameParts[1]
    },
    frameTypes() {
      return getFrameTypes(this.customisedProduct.baseSKU)
    },
    frameTypeFull() {
      if (this.customisedProduct.conversionKitEnabled)
        return this.frameTypes?.find((frame) => {
          return frame.conversionKit === true
        }).title

      return this.frameTypes?.find(
        (frame) => frame.frameType === this.frameType
      )?.title
    },
  },
}
</script>

<style lang="postcss">
.ProductTitleSection__prescription-title {
  @apply text-grey-500 text-xs font-light leading-tight mb-2;
}

.ProductTitleSection__product-description {
  @apply text-xs text-grey-500
    hidden md:block;
}

.ProductTitleSection__product-price {
  @apply block md:hidden;
}

.ProductTitleSection__frame-type {
  @apply text-xs;
}

.ProductTitleSection__container {
  @apply flex justify-between gap-x-5 mb-3 md:mb-2;
}

.ProductTitleSection__reviews-container {
  @apply flex items-start justify-between leading-none lg:pt-2;
}

/* Dark Chrome Theme */
.is-dark-chrome-theme {
  .ProductTitleSection {
    --vision-tag-background-color: theme('colors.grey.800');
  }
}
</style>
